import { generateKeys, generateLocalization } from '../utils';
import { activityLogTypes } from './activitylog';
import { userDepartments } from './user';
import { includes } from 'lodash';
import { companies } from './companies';
import { yesNo } from './general';
function isBdSwissBrand(company) {
    return includes([
        companies.bdSwiss.value,
        companies.bdSwissMauritius.value,
        companies.bdSwissVanuatu.value,
        companies.bdSwissSouthAfrica.value,
        companies.bdSwissComoros.value,
    ], company);
}
function isAffiliateClient(clientType) {
    return includes([
        clientTypes.affiliate.value,
        clientTypes.affiliateCorporate.value,
    ], clientType);
}
function isIB(clientType) {
    return includes([
        clientTypes.ib.value,
        clientTypes.ibCorporate.value,
    ], clientType);
}
export const signupSteps = generateLocalization('signupSteps', generateKeys({
    step1: {
        value: 'step_1',
        description: 'registration completion, go to profile detail',
        label: 'Profile',
        localization: { id: '', defaultMessage: '' },
    },
    step2: {
        value: 'step_2',
        description: 'profile details completion, go to approp test',
        label: 'Appropriateness Test',
        localization: { id: '', defaultMessage: '' },
    },
    step3: {
        value: 'step_3',
        description: 'appropriateness test completion, go to documents',
        label: 'Documents',
        localization: { id: '', defaultMessage: '' },
    },
    step4: {
        value: 'step_4',
        description: 'documents completion, exit wizard',
        label: '',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const profileChangeStatuses = generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    approved: {
        value: 'approved',
        label: 'Approved',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    underReview: {
        value: 'under_review',
        label: 'Under review',
    },
});
export const processProfileChangeResults = generateKeys({
    approve: {
        value: 'approve',
        label: 'Accept',
    },
    reject: {
        value: 'reject',
        label: 'Reject',
    },
    underReview: {
        value: 'underReview',
        label: 'Place under review',
    },
});
export const agentTypes = generateKeys({
    salesAgent: {
        value: 'sales_agent',
        label: 'Sales Agent',
        claimPerm: 'client_sales_claim',
        assignedPerm: 'client_sales_assigned',
        foreignKeyColumn: 'sales_agent_id',
        metadataEmail: 'sales_email',
    },
    supportAgent: {
        value: 'support_agent',
        label: 'Support Agent',
        claimPerm: 'client_support_claim',
        assignedPerm: 'client_support_assigned',
        foreignKeyColumn: 'support_agent_id',
        metadataEmail: 'support_email',
    },
    externalAgent: {
        value: 'external_agent',
        label: 'External Agent',
        claimPerm: 'client_external_claim',
        assignedPerm: 'client_external_agent_assigned',
        foreignKeyColumn: 'external_agent_id',
        metadataEmail: 'external_agent_email',
    },
});
export const tradingPositionStatuses = generateKeys({
    all: {
        value: '',
        label: 'All',
    },
    open: {
        value: 'open',
        label: 'Open',
    },
    closed: {
        value: 'closed',
        label: 'Closed',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
    },
});
export const notificationTextTypes = generateLocalization('notificationTextTypes', generateKeys({
    uploadRequestedDocumentation: {
        value: 'uploadRequestedDocumentation',
        label: 'Please upload the requested documentation',
        localization: { id: '', defaultMessage: '' },
    },
    replyOurEmailOrContactSupport: {
        value: 'replyOurEmailOrContactSupport',
        label: 'Please reply to our email or contact support',
        localization: { id: '', defaultMessage: '' },
    },
    updateEconomicProfile: {
        value: 'updateEconomicProfile',
        label: 'Please update your economic profile',
        localization: { id: '', defaultMessage: '' },
    },
    updateEconomicProfileAndKyc: {
        value: 'updateEconomicProfileAndKyc',
        label: 'Please update your economic profile and KYC',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const tradingStatusReasons = generateLocalization('tradingStatusReasons', generateKeys({
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.uploadRequestedDocumentation.value,
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    clientRequest: {
        value: 'clientRequest',
        label: 'As per your request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    missingKycDoc: {
        value: 'missingKycDoc',
        label: 'Due to missing KYC documentation',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.uploadRequestedDocumentation.value,
    },
    missingProofAddress: {
        value: 'missingProofAddress',
        label: 'Due to missing Proof of Address',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.uploadRequestedDocumentation.value,
    },
    missingProofOfId: {
        value: 'missingProofOfId',
        label: 'Due to missing Proof of Identification',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.uploadRequestedDocumentation.value,
    },
    missingProofOfPayment: {
        value: 'missingProofOfPayment',
        label: 'Due to missing Proof of Payment (i.e. card copies/bank statement)',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.uploadRequestedDocumentation.value,
    },
    thirdPartyTransaction: {
        value: 'thirdPartyTransaction',
        label: 'Third party transaction/s',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    duplicateProfile: {
        value: 'duplicateProfile',
        label: 'Duplicate profile/s',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.updateEconomicProfile.value,
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.updateEconomicProfile.value,
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    chargebackCase: {
        value: 'chargebackCase',
        label: 'Chargeback case',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    affiliateDeclined: {
        value: 'affiliateDeclined',
        label: 'Affiliate declined',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateNotCompliant: {
        value: 'affiliateNotCompliant',
        label: 'Affiliate not compliant',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateLowPerforming: {
        value: 'affiliateLowPerforming',
        label: 'Affiliate low performing',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateFraud: {
        value: 'affiliateFraud',
        label: 'Affiliate fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateClosed: {
        value: 'affiliateClosed',
        label: 'Affiliate closed',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    dormant: {
        value: 'dormant',
        label: 'Dormant',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    ibManualClosure: {
        value: 'ibManualClosure',
        label: 'IB manual closure',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        category: 'IB',
    },
    ibAutomatedClosure: {
        value: 'ibAutomatedClosure',
        label: 'IB automated closure',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'IB',
    },
    complianceReasons: {
        value: 'complianceReasons',
        label: 'Compliance reasons',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    suspiciousActivity: {
        value: 'suspiciousActivity',
        label: 'Suspicious activity/transactions',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    thirdPartyDeposits: {
        value: 'thirdPartyDeposits',
        label: 'Third party deposits',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    cardCopiesRequired: {
        value: 'cardCopiesRequired',
        label: 'Card copies required',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.uploadRequestedDocumentation.value,
    },
    numberFailedTransactions: {
        value: 'numberFailedTransactions',
        label: 'Due to number of failed transactions/ reason of the failed transaction',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    compliance: {
        value: 'compliance',
        label: 'Compliance',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    suspiciousTradingBehavior: {
        value: 'suspiciousTradingBehavior',
        label: 'Suspicious trading/funding behavior',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    pepOrUs: {
        value: 'pepOrUs',
        label: 'As you have declared to be a Politically exposed person / US Reportable client',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.updateEconomicProfile.value,
    },
    sameDepositMethodForDifferentProfiles: {
        value: 'sameDepositMethodForDifferentProfiles',
        label: 'Same deposit method for different profiles',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    duplicateLead: {
        value: 'duplicateLead',
        label: 'Possible duplicate lead',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.replyOurEmailOrContactSupport.value,
    },
    resubmitEconomicProfile: {
        value: 'resubmitEconomicProfile',
        label: 'Economic profile to be re-completed ',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.updateEconomicProfile.value,
    },
    resubmitEconomicProfileKYC: {
        value: 'resubmitEconomicProfileKYC',
        label: 'Economic profile and KYC',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        notificationText: notificationTextTypes.updateEconomicProfileAndKyc.value,
    },
}));
export const kycRejectionReasons = generateLocalization('kycRejectionReasons', generateKeys({
    proofOfAddress: {
        value: 'proofOfAddress',
        label: 'Updated Proof of address is required',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    renewedProofOfIdentification: {
        value: 'renewedProofOfIdentification',
        label: 'Renewed Proof of Identification is required',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    updatedKycDocuments: {
        value: 'updatedKycDocuments',
        label: 'Updated KYC documents (Proof of Identity and Proof of address) are required',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    resubmissionOfAppTest: {
        value: 'resubmissionOfAppTest',
        label: 'Resubmission of Appropriateness test is required',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    additionalDocumentation: {
        value: 'additionalDocumentation',
        label: 'Additional documentation is required due to third party deposits',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    copiesOfCreditDebitCards: {
        value: 'copiesOfCreditDebitCards',
        label: 'Copies of the used credit/debit cards for verification of your deposits',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    bankStatement: {
        value: 'bankStatement',
        label: 'Bank statement or other relevant source of funds document must be provided',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const suspendedTradingStatusReasons = generateLocalization('suspendedTradingStatusReasons', generateKeys({
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    missingKycDoc: {
        value: 'missingKycDoc',
        label: 'Due to missing KYC documentation',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingProofAddress: {
        value: 'missingProofAddress',
        label: 'Due to missing Proof of Address',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingProofOfId: {
        value: 'missingProofOfId',
        label: 'Due to missing Proof of Identification',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    missingProofOfPayment: {
        value: 'missingProofOfPayment',
        label: 'Due to missing Proof of Payment (i.e. card copies/bank statement)',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    thirdPartyTransaction: {
        value: 'thirdPartyTransaction',
        label: 'Third party transaction/s',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    chargebackCase: {
        value: 'chargebackCase',
        label: 'Chargeback case',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const closedTradingStatusReasons = generateLocalization('closedTradingStatusReasons', generateKeys({
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    clientRequest: {
        value: 'clientRequest',
        label: 'As per your request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    affiliateDeclined: {
        value: 'affiliateDeclined',
        label: 'Affiliate declined',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateNotCompliant: {
        value: 'affiliateNotCompliant',
        label: 'Affiliate not compliant',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateLowPerforming: {
        value: 'affiliateLowPerforming',
        label: 'Affiliate low performing',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateFraud: {
        value: 'affiliateFraud',
        label: 'Affiliate fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    affiliateClosed: {
        value: 'affiliateClosed',
        label: 'Affiliate closed',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'Affiliate',
        supressEmail: true,
    },
    dormant: {
        value: 'dormant',
        label: 'Dormant',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    ibManualClosure: {
        value: 'ibManualClosure',
        label: 'IB manual closure',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        category: 'IB',
    },
    ibAutomatedClosure: {
        value: 'ibAutomatedClosure',
        label: 'IB automated closure',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
        category: 'IB',
    },
    complianceReasons: {
        value: 'complianceReasons',
        label: 'Compliance reasons',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
    },
    suspiciousActivity: {
        value: 'suspiciousActivity',
        label: 'Suspicious activity/transactions',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const rejectedTradingStatusReasons = generateLocalization('rejectedTradingStatusReasons', generateKeys({
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    clientRequest: {
        value: 'clientRequest',
        label: 'As per your request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    ibManualClosure: {
        value: 'ibManualClosure',
        label: 'IB manual closure',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        category: 'IB',
    },
    complianceReasons: {
        value: 'complianceReasons',
        label: 'Compliance reasons',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
    },
    suspiciousActivity: {
        value: 'suspiciousActivity',
        label: 'Suspicious activity/transactions',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const appropTestRejectionReasons = generateLocalization('appropTestRejectionReasons', generateKeys({
    politicallyExposed: {
        value: 'politicallyExposed',
        label: 'You have declared to be politically exposed person (\'PEP\')',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    insufficientTradingExp: {
        value: 'insufficientTradingExp',
        label: `You have declared to have no risk understanding in regards to trading Forex/CFD
      and/or Binary Options. Please read the Risk Disclaimer available on our website.`,
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    usReportable: {
        value: 'usReportable',
        label: 'You have declared to be US reportable person, however failed to provide us with valid/correct TIN number',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const claimedStatuses = generateKeys({
    claimed: {
        value: 'claimed',
        label: 'Assigned',
    },
    unclaimed: {
        value: 'unclaimed',
        label: 'Unassigned',
    },
});
export const tradingStatuses = generateLocalization('tradingStatuses', generateKeys({
    newAccount: {
        value: 'new_account',
        label: 'Missing AP Test',
        allowTransition: () => true,
        bsStyle: 'info',
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '1' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: false },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 1, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        canLogin: true,
        canTrade: false,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
    registered: {
        value: 'registered',
        label: 'Registered',
        labelAction: 'Activate',
        bsStyle: 'info',
        allowTransition: () => false,
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '0' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: true },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 0, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        canLogin: true,
        canTrade: true,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
    depositor: {
        value: 'depositor',
        label: 'Depositor',
        labelAction: 'Activate',
        bsStyle: 'success',
        allowTransition: () => false,
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '0' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: true },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 0, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        canLogin: true,
        canTrade: true,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
    active: {
        value: 'active',
        label: 'Active',
        labelAction: 'Activate',
        bsStyle: 'success',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '0' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: true },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 0, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        affiliateValue: 'Approved',
        canLogin: true,
        canTrade: true,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
    suspended: {
        value: 'suspended',
        label: 'Suspended',
        labelAction: 'Suspend',
        bsStyle: 'warning',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'pending', regulateStatus: 'pending' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '1' },
        forexDemoValue: { enable: '1', readonly: '1' },
        cuboidValue: { deleted: false, enabled: false },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 1, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        affiliateValue: 'Suspended',
        canLogin: true,
        canTrade: false,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelAction: 'Reject',
        bsStyle: 'danger',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'pending', regulateStatus: 'suspend' },
        spotOptionDemoValue: { regStatus: 'pending', regulateStatus: 'suspend' },
        forexValue: { enable: '0', readonly: '0', send_reports: '0' },
        forexDemoValue: { enable: '0', readonly: '0', send_reports: '0' },
        cuboidValue: { deleted: true, enabled: false },
        cuboidDemoValue: { deleted: true, enabled: false },
        tradesmarterValue: { frozen: 1, blocked: 1 },
        tradesmarterDemoValue: { frozen: 1, blocked: 1 },
        canLogin: false,
        canTrade: false,
        canDeposit: false,
        canWithdraw: false,
        warningMessage: 'Rejecting client\'s account is permanent. Are you sure?',
        localization: { id: '', defaultMessage: '' },
    },
    closed: {
        value: 'closed',
        label: 'Closed',
        labelAction: 'Close',
        bsStyle: 'danger',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'pending', regulateStatus: 'suspend' },
        spotOptionDemoValue: { regStatus: 'pending', regulateStatus: 'suspend' },
        forexValue: { enable: '0', readonly: '0', send_reports: '0' },
        forexDemoValue: { enable: '0', readonly: '0', send_reports: '0' },
        cuboidValue: { deleted: true, enabled: false },
        cuboidDemoValue: { deleted: true, enabled: false },
        tradesmarterValue: { frozen: 1, blocked: 1 },
        tradesmarterDemoValue: { frozen: 1, blocked: 1 },
        affiliateValue: 'Blocked',
        canLogin: false,
        canTrade: false,
        canDeposit: false,
        canWithdraw: false,
        warningMessage: 'Closing client\'s account is permanent. Are you sure?',
        localization: { id: '', defaultMessage: '' },
    },
    dormant: {
        value: 'dormant',
        label: 'Dormant',
        labelAction: 'Set Dormant',
        bsStyle: 'danger',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '0' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: true },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 0, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        canLogin: true,
        canTrade: true,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: 'Setting client\'s account to dormant. Are you sure?',
        localization: { id: '', defaultMessage: '' },
    },
    inactive: {
        value: 'inactive',
        label: 'Inactive',
        labelAction: 'Set Inactive',
        bsStyle: 'warning',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '0' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: true },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 0, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        canLogin: true,
        canTrade: true,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
    terminated: {
        value: 'terminated',
        label: 'Terminated',
        labelAction: 'Terminate',
        bsStyle: 'danger',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'pending', regulateStatus: 'suspend' },
        spotOptionDemoValue: { regStatus: 'pending', regulateStatus: 'suspend' },
        forexValue: { enable: '0', readonly: '0', send_reports: '0' },
        forexDemoValue: { enable: '0', readonly: '0', send_reports: '0' },
        cuboidValue: { deleted: true, enabled: false },
        cuboidDemoValue: { deleted: true, enabled: false },
        tradesmarterValue: { frozen: 1, blocked: 1 },
        tradesmarterDemoValue: { frozen: 1, blocked: 1 },
        canLogin: false,
        canTrade: false,
        canDeposit: false,
        canWithdraw: false,
        warningMessage: 'Terminating client is permanent. Are you sure?',
        localization: { id: '', defaultMessage: '' },
    },
    warning: {
        value: 'warning',
        label: 'Warning',
        labelAction: 'Warning',
        bsStyle: 'warning',
        allowTransition: () => true,
        spotOptionValue: { regStatus: 'activated', regulateStatus: 'approve' },
        spotOptionDemoValue: { regStatus: 'activated', regulateStatus: 'approve' },
        forexValue: { enable: '1', readonly: '0' },
        forexDemoValue: { enable: '1', readonly: '0' },
        cuboidValue: { deleted: false, enabled: true },
        cuboidDemoValue: { deleted: false, enabled: true },
        tradesmarterValue: { frozen: 0, blocked: 0 },
        tradesmarterDemoValue: { frozen: 0, blocked: 0 },
        canLogin: true,
        canTrade: true,
        canDeposit: true,
        canWithdraw: true,
        warningMessage: '',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const warningType = generateKeys({
    underMonitoring: {
        value: 'underMonitoring',
        label: 'Under Monitoring',
        warningReasons: 'underMonitoringReasons',
    },
    suspended: {
        value: 'suspended',
        label: 'Suspended',
        warningReasons: 'suspendedTradingStatusReasons',
    },
    terminated: {
        value: 'terminated',
        label: 'Terminated',
        warningReasons: 'terminatedTradingStatusReasons',
    },
});
export const cannotTradeReasons = generateLocalization('cannotTradeReasons', generateKeys({
    tradingStatus: {
        value: 'trading_status',
        label: 'Trading disabled by trading status',
        canTradeDemo: false,
        localization: { id: '', defaultMessage: '' },
    },
    appropTestRejected: {
        value: 'approp_test_rejected',
        label: 'Appropriateness test was rejected',
        canTradeDemo: true,
        localization: { id: '', defaultMessage: '' },
    },
    appropTestMissing: {
        value: 'approp_test_missing',
        label: 'Appropriateness test is missing',
        canTradeDemo: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const kycStatuses = generateLocalization('kycStatuses', generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
        bsStyle: 'secondary',
        icon: 'warning',
        localization: { id: '', defaultMessage: '' },
    },
    approved: {
        value: 'approved',
        label: 'Approved',
        bsStyle: 'success',
        icon: 'check-circle',
        localization: { id: '', defaultMessage: '' },
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        bsStyle: 'danger',
        icon: 'times-circle',
        localization: { id: '', defaultMessage: '' },
    },
    pendingAppropTest: {
        value: 'pendingAppropTest',
        label: 'AP Pending',
        bsStyle: 'primary',
        icon: 'times-circle',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const clientCategories = generateKeys({
    retail: {
        value: 'retail',
        label: 'Retail',
    },
    professional: {
        value: 'professional',
        label: 'Professional',
    },
    eligibleCounterparty: {
        value: 'eligible_counterparty',
        label: 'Eligible Counterparty',
    },
});
export const clientGBGTypes = generateKeys({
    pass: {
        value: 'pass',
        label: 'Pass',
        id3Value: 'PASS',
    },
    refer: {
        value: 'refer',
        label: 'Refer',
        id3Value: 'REFER',
    },
    alert: {
        value: 'alert',
        label: 'Alert',
        id3Value: 'ALERT',
    },
});
export const conversionStatuses = generateKeys({
    duplicate: {
        value: 'duplicate',
        label: 'Duplicate',
        userAssignable: true,
    },
    lead: {
        value: 'lead',
        label: 'Lead',
        userAssignable: true,
    },
    converted: {
        value: 'converted',
        label: 'Converted',
        userAssignable: true,
    },
    noAnswer: {
        value: 'no_answer',
        label: 'No Answer',
        userAssignable: true,
    },
    doNotCall: {
        value: 'do_not_call',
        label: 'Do Not Call',
        userAssignable: true,
    },
    callAgain: {
        value: 'call_again',
        label: 'Call Again',
        userAssignable: true,
    },
    checkNumber: {
        value: 'check_number',
        label: 'Check Number',
        userAssignable: true,
    },
    reassigned: {
        value: 'reassigned',
        label: 'Reassigned',
        userAssignable: true,
    },
    interested: {
        value: 'interested',
        label: 'Interested',
        userAssignable: true,
    },
    vipClient: {
        value: 'vip_client',
        label: 'VIP Client',
        userAssignable: true,
    },
    topVipClient: {
        value: 'top_vip_client',
        label: 'Top VIP Client',
        userAssignable: true,
    },
    unregisteredLead: {
        value: 'unregistered_lead',
        label: 'Unregistered Lead',
        userAssignable: false,
    },
    pamm: {
        value: 'pamm',
        label: 'PAMM',
        userAssignable: true,
    },
    lead_language_barrier: {
        value: 'lead_language_barrier',
        label: 'Lead Language Barrier',
        userAssignable: true,
    },
    abusive: {
        value: 'abusive',
        label: 'Abusive Account',
        userAssignable: true,
    },
    mobile: {
        value: 'mobile',
        label: 'Mobile Reassigned',
        userAssignable: true,
    },
    onboarding: {
        value: 'onboarding',
        label: 'On Boarding',
        userAssignable: true,
    },
    churn: {
        value: 'churn',
        label: 'Churn',
        userAssignable: true,
    },
    nec60Days: {
        value: 'nec_60_days',
        label: 'No Effective Call For 60 Days',
        userAssignable: true,
    },
    notInterested: {
        value: 'notInterested',
        label: 'Not Interested',
        userAssignable: true,
    },
    emailContact: {
        value: 'emailContact',
        label: 'Email Contact',
        userAssignable: true,
    },
    voiceMail: {
        value: 'voiceMail',
        label: 'Voice Mail',
        userAssignable: true,
    },
});
export const clientTypes = generateKeys({
    retail: {
        value: 'retail',
        label: 'Retail',
        isIndividual: true,
    },
    ib: {
        value: 'ib',
        label: 'IB',
        isIndividual: true,
    },
    affiliate: {
        value: 'affiliate',
        label: 'Affiliate',
        isIndividual: true,
    },
    corporate: {
        value: 'corporate',
        label: 'Corporate',
        isIndividual: false,
        allowClientRegistration: true,
    },
    ibCorporate: {
        value: 'ibCorporate',
        label: 'IB Corporate',
        isIndividual: false,
    },
    affiliateCorporate: {
        value: 'affiliateCorporate',
        label: 'Affiliate Corporate',
        isIndividual: false,
    },
    jointAccount: {
        value: 'jointAccount',
        label: 'Joint Account',
        isIndividual: false,
    },
    testClient: {
        value: 'testClient',
        label: 'Test',
        isIndividual: true,
    },
    merchant: {
        value: 'merchant',
        label: 'Merchant',
        isIndividual: false,
    },
    professional: {
        value: 'professional',
        label: 'Professional',
        isIndividual: true,
    },
    eligibleCounterParty: {
        value: 'eligibleCounterParty',
        label: 'Eligible Counterparty',
        isIndividual: false,
    },
    strategicPartner: {
        value: 'strategicPartner',
        label: 'Strategic Partner',
        isIndividual: false,
    },
    fundAgent: {
        value: 'fundAgent',
        label: 'Fund Agent',
        isIndividual: true,
    },
    fundInvestor: {
        value: 'fundInvestor',
        label: 'Fund Investor',
        isIndividual: true,
    },
    contractor: {
        value: 'contractor',
        label: 'Contractor',
        isIndividual: true,
    },
});
export const clientWalkthroughs = generateKeys({
    websiteWalkThrough: {
        value: 'website_walkthrough',
        code: 'WT01',
        label: 'Dashboard Walkthrough (Deposits, Withdrawals)',
        deleteActivityLogType: activityLogTypes.websiteWalkthroughDeleted,
        providedActivityLogType: activityLogTypes.websiteWalkthroughProvided,
    },
    mt4WalkThrough: {
        value: 'mt4_walkthrough',
        code: 'WT02',
        label: 'Trading Walkthrough (MT4, Webtrader, Mobile)',
        deleteActivityLogType: activityLogTypes.mt4WalkthroughDeleted,
        providedActivityLogType: activityLogTypes.mt4WalkthroughProvided,
    },
    binaryWalkThrough: {
        value: 'binary_walkthrough',
        code: 'WT03',
        label: 'Binary Walkthrough',
        disabled: true,
        deleteActivityLogType: activityLogTypes.binaryWalkthroughDeleted,
        providedActivityLogType: activityLogTypes.binaryWalkthroughProvided,
    },
});
export const clientNoticeTypes = generateKeys({
    termsChange: {
        value: 'tc_change',
        label: 'Terms and Conditions Change Notice',
    },
    informative: {
        value: 'informative',
        label: 'Informative Notice',
    },
    partners: {
        value: 'partners',
        label: 'Partners',
    },
    migration: {
        value: 'migration',
        label: 'Migration notice',
    },
});
export const clientNoticeAcknowledgementTypes = generateKeys({
    seen: {
        value: 'seen',
        label: 'Seen',
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
    },
    dismissed: {
        value: 'dismissed',
        label: 'dismissed',
    },
    remindLater: {
        value: 'remind_later',
        label: 'Remind Later',
    },
    declined: {
        value: 'declined',
        label: 'Declined',
    },
});
export const helpOptions = generateLocalization('helpOptions', generateKeys({
    general: {
        value: 'general',
        label: 'General',
        email: 'support@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    deposits: {
        value: 'deposits',
        label: 'Deposits',
        email: 'funding@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    withdrawals: {
        value: 'withdrawals',
        label: 'Withdrawals',
        email: 'funding@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    kycDocuments: {
        value: 'kycDocuments',
        label: 'KYC Documents',
        email: 'backoffice@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    trading: {
        value: 'trading',
        label: 'Trading',
        email: 'support@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    mobileApp: {
        value: 'mobileApp',
        label: 'Mobile App',
        email: 'support@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    forgotPassword: {
        value: 'forgotPassword',
        label: 'Forgot Password',
        email: 'support@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
    partnerships: {
        value: 'partnerships',
        label: 'Partnerships',
        email: 'partnership@bdswiss.com',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const agentPoolFilter = generateKeys({
    poolonly: {
        value: 'poolonly',
        label: 'Pool Only',
    },
    hidepool: {
        value: 'hidepool',
        label: 'Hide Pool',
    },
});
export const spoaStatuses = generateLocalization('spoaStatuses', generateKeys({
    successfulAuthorization: {
        value: 'successfulAuthorization',
        message: 'IB was authorized.',
        label: 'IB was authorized.',
        localization: { id: '', defaultMessage: '' },
    },
    notFound: {
        value: 'notFound',
        message: 'IB not found',
        label: 'IB not found',
        localization: { id: '', defaultMessage: '' },
    },
    cannotGrantSpoa: {
        value: 'cannotGrantSpoa',
        message: 'Not authorized to grant SPOA',
        label: 'Not authorized to grant SPOA',
        localization: { id: '', defaultMessage: '' },
    },
    notAuthorized: {
        value: 'notAuthorized',
        message: 'IB not authorized (no permission)',
        label: 'IB not authorized (no permission)',
        localization: { id: '', defaultMessage: '' },
    },
    successfulRevocation: {
        value: 'successfulRevocation',
        message: 'IB\'s authorization was revoked',
        label: 'IB\'s authorization was revoked',
        localization: { id: '', defaultMessage: '' },
    },
    notPermitted: {
        value: 'notPermitted',
        message: 'This action is not permitted. You cannot grant SPOA authorization under the same profile.',
        label: 'This action is not permitted. You cannot grant SPOA authorization under the same profile.',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const phoneTypes = generateKeys({
    primary: {
        value: 'primary',
        label: 'Primary',
    },
    secondary: {
        value: 'secondary',
        label: 'Secondary',
    },
});
export const underMonitoringReasons = generateLocalization('underMonitoringReasons', generateKeys({
    thirdPartyDeposits: {
        value: 'thirdPartyDeposits',
        label: 'Third party deposits',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    cardCopiesRequired: {
        value: 'cardCopiesRequired',
        label: 'Card copies required',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    numberFailedTransactions: {
        value: 'numberFailedTransactions',
        label: 'Due to number of failed transactions/ reason of the failed transaction',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    compliance: {
        value: 'compliance',
        label: 'Compliance',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    suspiciousTradingBehavior: {
        value: 'suspiciousTradingBehavior',
        label: 'Suspicious trading/funding behavior',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    pepOrUs: {
        value: 'pepOrUs',
        label: 'As you have declared to be a Politically exposed person / US Reportable client',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    sameDepositMethodForDifferentProfiles: {
        value: 'sameDepositMethodForDifferentProfiles',
        label: 'Same deposit method for different profiles',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateLead: {
        value: 'duplicateLead',
        label: 'Possible duplicate lead',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitEconomicProfile: {
        value: 'resubmitEconomicProfile',
        label: 'Economic profile to be re-completed ',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    resubmitEconomicProfileKYC: {
        value: 'resubmitEconomicProfileKYC',
        label: 'Economic profile and KYC',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    chargebackCase: {
        value: 'chargebackCase',
        label: 'Chargeback case',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    sameWithdrawalMethodForDifferentProfiles: {
        value: 'sameWithdrawalMethodForDifferentProfiles',
        label: 'Same withdrawal details with different profiles',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const clientSearchTypes = generateKeys({
    affiliate: {
        value: 'affiliate',
    },
});
export const signableNotices = generateKeys({
    generalCFDDisclaimer: {
        value: 'generalCFDDisclaimer',
        label: 'Spanish Disclaimer',
    },
});
export const clientPotentialLevels = generateKeys({
    lowPotential: {
        value: 'lowPotential',
        code: 'LOW',
        label: 'Low Potential',
    },
    mediumPotential: {
        value: 'mediumPotential',
        code: 'MEDIUM',
        label: 'Medium Potential',
    },
    highPotential: {
        value: 'highPotential',
        code: 'HIGH',
        label: 'High Potential',
    },
});
export const campaignRating = generateKeys({
    ['s1']: { value: 's1', label: '★☆☆☆☆' },
    ['s2']: { value: 's2', label: '★★☆☆☆' },
    ['s3']: { value: 's3', label: '★★★☆☆' },
    ['s4']: { value: 's4', label: '★★★★☆' },
    ['s5']: { value: 's5', label: '★★★★★' },
});
export const clientRating = generateKeys({
    ['s1']: { value: 's1', label: '★☆☆☆☆' },
    ['s2']: { value: 's2', label: '★★☆☆☆' },
    ['s3']: { value: 's3', label: '★★★☆☆' },
    ['s4']: { value: 's4', label: '★★★★☆' },
    ['s5']: { value: 's5', label: '★★★★★' },
});
export const clientRatingReason = generateKeys({
    ['invalid_number']: { value: 'invalid_number', label: 'Wrong / invalid phone number', rating: 's1' },
    ['notKnowWhat']: { value: 'notKnowWhat', label: 'Does not know what they signed up for', rating: 's1' },
    ['pickHang']: { value: 'pickHang', label: 'Pick up / hang up', rating: 's1' },
    ['noAnswer']: { value: 'noAnswer', label: 'No answer', rating: 's1' },
    ['notInterested']: { value: 'notInterested', label: 'Not interested', rating: 's1' },
    ['interestNoAnswer']: { value: 'interestNoAnswer', label: 'Like to get information, then no answer', rating: 's2' },
    ['affiliateNoSpeak']: { value: 'affiliateNoSpeak', label: 'Affiliate said not to speak with agent', rating: 's2' },
    ['onlyEmail']: { value: 'onlyEmail', label: 'No answer / only email contact', rating: 's2' },
    ['oneCallNoAnswer']: { value: 'oneCallNoAnswer', label: 'First call pick up / never again', rating: 's2' },
    ['notInterestedServices']: { value: 'notInterestedServices', label: 'Not interested in our services', rating: 's2' },
    ['appNoAnswer']: { value: 'appNoAnswer', label: 'Set up app, then no answer', rating: 's3' },
    ['invalidNumberSelfDeposit']: { value: 'invalidNumberSelfDeposit', label: 'invalid number + self deposit', rating: 's3' },
    ['signupNoLogin']: { value: 'signupNoLogin', label: 'Sign up / never log in again', rating: 's3' },
    ['documentsUpload']: { value: 'documentsUpload', label: 'Documents are uploaded', rating: 's3' },
    ['interestNoMoney']: { value: 'interestNoMoney', label: 'Interested but no money', rating: 's3' },
    ['callDeposit']: { value: 'callDeposit', label: 'Support call, then deposit', rating: 's4' },
    ['ftdNoInterestedServices']: { value: 'ftdNoInterestedServices', label: 'FTD but not interested in our services', rating: 's4' },
    ['ftdLowAmount']: { value: 'ftdLowAmount', label: 'FTD but low amount', rating: 's4' },
    ['ftdMinimumDeposit']: { value: 'ftdMinimumDeposit', label: 'FTD but with minimum deposit', rating: 's4' },
    ['ftdOnlyCopyTrading']: { value: 'ftdOnlyCopyTrading', label: 'FTD only copy trading', rating: 's4' },
    ['appDeposit']: { value: 'appDeposit', label: 'Set up app, then deposit', rating: 's5' },
    ['appCallDeposit']: { value: 'appCallDeposit', label: 'APP, follow up call, then deposit', rating: 's5' },
    ['selfDeposit']: { value: 'selfDeposit', label: 'Self deposit', rating: 's5' },
    ['onlineThenDeposit']: { value: 'onlineThenDeposit', label: 'Online, then deposit', rating: 's5' },
    ['emailDeposit']: { value: 'emailDeposit', label: 'Like info per email, then deposit', rating: 's5' },
});
export const phoneVerificationTypes = generateKeys({
    sms: {
        value: 'sms',
        label: 'SMS',
    },
    textToSpeech: {
        value: 'textToSpeech',
        label: 'Text To Speech',
    },
});
export const deleteIBWalletReasons = generateLocalization('deleteIBWalletReasons', generateKeys({
    complianceTerminated: {
        value: 'complianceTerminated',
        label: 'Terminated as per Compliance',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    inactive: {
        value: 'inactive',
        label: 'Terminated Inactive',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    clientRequest: {
        value: 'clientRequest',
        label: 'Close account as per your request',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    wrongCurrency: {
        value: 'wrongCurrency',
        label: 'Wrong Wallet currency',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const copyTradingProviderTypes = generateKeys({
    ib: {
        value: 'ib',
        label: 'IB',
    },
    affiliate: {
        value: 'affiliate',
        label: 'Affiliate',
    },
});
export const allocationMethodTypes = generateLocalization('allocationMethodTypes', generateKeys({
    proportionCopy: {
        value: 'proportionCopy',
        label: 'Proportion copy',
        providerTypes: [
            copyTradingProviderTypes.ib.value,
            copyTradingProviderTypes.affiliate.value,
        ],
        localization: { id: '', defaultMessage: '' },
    },
    copyByPercentage: {
        value: 'copyByPercentage',
        label: 'Copy by percentage',
        disabled: true,
        providerTypes: [
            copyTradingProviderTypes.ib.value,
        ],
        localization: { id: '', defaultMessage: '' },
    },
}));
export const copyByPercentageValues = generateKeys({
    by50: {
        value: 'by50',
        label: '50%',
    },
    by100: {
        value: 'by100',
        label: '100%',
    },
    by200: {
        value: 'by200',
        label: '200%',
    },
    by300: {
        value: 'by300',
        label: '300%',
    },
    by400: {
        value: 'by400',
        label: '400%',
    },
    by500: {
        value: 'by500',
        label: '500%',
    },
});
export const themePreferenceOptions = generateKeys({
    light: {
        value: 'light',
        label: 'Light Theme',
    },
    dark: {
        value: 'dark',
        label: 'Dark Theme',
    },
});
export const terminatedTradingStatusReasons = generateLocalization('terminatedTradingStatusReasons', generateKeys({
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
    ibManualClosure: {
        value: 'ibManualClosure',
        label: 'IB manual closure',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        category: 'IB',
        disabled: true,
    },
    complianceReasons: {
        value: 'complianceReasons',
        label: 'Compliance reasons',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
    },
    suspiciousActivity: {
        value: 'suspiciousActivity',
        label: 'Suspicious activity/transactions',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
        supressEmail: true,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const referralStatuses = generateLocalization('referralStatuses', generateKeys({
    claimed: {
        value: 'claimed',
        label: 'Claimed',
        localization: { id: '', defaultMessage: '' },
    },
    activated: {
        value: 'activated',
        label: 'Activated',
        localization: { id: '', defaultMessage: '' },
    },
    deposited: {
        value: 'deposited',
        label: 'Deposited',
        localization: { id: '', defaultMessage: '' },
    },
    verified: {
        value: 'verified',
        label: 'Verified',
        localization: { id: '', defaultMessage: '' },
    },
    pendingActivation: {
        value: 'pendingActivation',
        label: 'Pending Activation',
        localization: { id: '', defaultMessage: '' },
    },
    clientDeclined: {
        value: 'clientDeclined',
        label: 'Client Declined',
        localization: { id: '', defaultMessage: '' },
    },
    activationOverdue: {
        value: 'activationOverdue',
        label: 'Activation Overdue',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const memberRanks = generateKeys({
    regular: {
        value: 'regular',
        label: 'Regular',
    },
    pro: {
        value: 'pro',
        label: 'Pro',
    },
    loyal: {
        value: 'loyal',
        label: 'Loyal',
    },
});
export const copyTradingFilterTypes = generateKeys({
    providersPerformanceFee: {
        value: 'providersPerformanceFee',
        label: 'Providers Performance Fee',
    },
    providersRebate: {
        value: 'providersRebate',
        label: 'Providers Rebate',
    },
    allProviders: {
        value: 'allProviders',
        label: 'All Providers',
    },
    copiersPerformanceFee: {
        value: 'copiersPerformanceFee',
        label: 'Copiers Performance Fee',
    },
    copiersRebate: {
        value: 'copiersRebate',
        label: 'Copiers Rebate',
    },
    allCopiers: {
        value: 'allCopiers',
        label: 'All Copiers',
    },
});
export const copyTradingDisableReasons = generateLocalization('copyTradingDisableReasons', generateKeys({
    archivedProviderAccount: {
        value: 'archivedProviderAccount',
        label: 'Archived provider account',
        showReasonTextArea: false,
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
        localization: { id: '', defaultMessage: '' },
    },
}));
export const salesAgentEmailTemplateReasons = generateKeys({
    notAnswerFirstCall: {
        value: 'notAnswerFirstCall',
        label: 'We have tried to contact you',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    noExperienceClient: {
        value: 'noExperienceClient',
        label: 'BDswiss Trading Academy Information',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    interestedClient: {
        value: 'interestedClient',
        label: 'Activating your account with BDSwiss ',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    vipSignalsLink: {
        value: 'vipSignalsLink',
        label: 'Access to VIP Signals link',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    informationAfterCall: {
        value: 'informationAfterCall',
        label: 'Thank you for registering with BDSwiss',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    invalidNumberRetention: {
        value: 'invalidNumberRetention',
        label: 'The Information On Your Account Appears To Be Incorrect',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    invalidNumberConversion: {
        value: 'invalidNumberConversion',
        label: 'Your contact details ',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    accountManagerBenefits: {
        value: 'accountManagerBenefits',
        label: 'Following Up To Our Call',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    introForNewbies: {
        value: 'introForNewbies',
        label: 'Your Free Educational Material',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    noAnswerFirst: {
        value: 'noAnswerFirst',
        label: 'Your BDSwiss Account Manager ',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    noAnswerSecond: {
        value: 'noAnswerSecond',
        label: 'Trying To Reach You',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    noAnswerThird: {
        value: 'noAnswerThird',
        label: 'Information On Your BDSwiss Account',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    triedToReachYou: {
        value: 'triedToReachYou',
        label: 'Your Account Manager Trying To Reach You',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    autochartist: {
        value: 'autochartist',
        label: 'Your Meta Trader 4 AutoChartist Plug-In',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    missedAppointment: {
        value: 'missedAppointment',
        label: 'Your Appointment With Your Account Manager',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    marginWarning: {
        value: 'marginWarning',
        label: 'URGENT! Your Accounts Margin',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    oneOnOneTraining: {
        value: 'oneOnOneTraining',
        label: 'Opportunity For a One-On-One Trading Session',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    withdrawal: {
        value: 'withdrawal',
        label: 'Your Recent Withdrawal',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    tradeComplaint: {
        value: 'tradeComplaint',
        label: 'Your Trade Complaint',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
    trustpilot: {
        value: 'trustpilot',
        label: 'Trustpilot',
        isAvailable: (viewer, client) => (includes([userDepartments.sales.value, userDepartments.businessDevelopment.value, userDepartments.support.value], viewer.department))
            && isBdSwissBrand(client.company) && !client.whiteLabel,
    },
    googleReviews: {
        value: 'googleReviews',
        label: 'Google Reviews',
        isAvailable: (viewer, client) => (includes([userDepartments.sales.value, userDepartments.businessDevelopment.value, userDepartments.support.value], viewer.department))
            && isBdSwissBrand(client.company) && !client.whiteLabel,
    },
    fpaReviews: {
        value: 'fpaReviews',
        label: 'FPA Reviews',
        isAvailable: (viewer, client) => (includes([userDepartments.sales.value, userDepartments.businessDevelopment.value, userDepartments.support.value], viewer.department))
            && isBdSwissBrand(client.company) && !client.whiteLabel,
    },
    affiliateContract: {
        value: 'affiliateContract',
        label: 'Affiliate Deal Agreement',
        isAvailable: (viewer, client) => includes([userDepartments.affiliate.value, userDepartments.dealing.value], viewer.department) && isAffiliateClient(client.clientType),
        noReply: true,
    },
    affiliateContractExisting: {
        value: 'affiliateContractExisting',
        label: 'Affiliate Deal Agreement (Existing)',
        isAvailable: (viewer, client) => includes([userDepartments.affiliate.value, userDepartments.dealing.value], viewer.department) && isAffiliateClient(client.clientType),
        noReply: true,
    },
    ibCommission: {
        value: 'ibCommission',
        label: 'IB Commission',
        isAvailable: (_, client) => isIB(client.clientType),
        noReply: true,
    },
    survey: {
        value: 'survey',
        label: 'Client Satisfaction Survey (Sales agents)',
        isAvailable: (viewer) => includes([userDepartments.sales.value, userDepartments.businessDevelopment.value], viewer.department),
    },
});
export const verificationTypes = generateLocalization('verificationTypes', generateKeys({
    login: {
        value: 'login',
        label: 'Login',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const ibNetworkOptions = generateKeys({
    entire: {
        value: 'entire',
        label: 'Entire',
    },
    direct: {
        value: 'direct',
        label: 'Direct',
    },
});
export const existingOrNewClients = generateKeys({
    new: {
        value: 'new',
        label: 'New ONLY',
    },
    newAndExisting: {
        value: 'newAndExisting',
        label: 'New and Existing',
    },
});
export const profileChangeFields = generateKeys({
    firstName: {
        path: 'firstName',
        label: 'First Name',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    lastName: {
        path: 'lastName',
        label: 'Last Name',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    birthday: {
        path: 'birthday',
        label: 'Birthday',
        department: userDepartments.boAccountOpening.value,
    },
    phone: {
        path: 'phone',
        label: 'Phone',
        department: 'noDepartment',
    },
    gender: {
        path: 'gender',
        label: 'Gender',
        department: userDepartments.boAccountOpening.value,
    },
    nationality: {
        path: 'nationality',
        label: 'Nationality',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    language: {
        path: 'language',
        label: 'Language',
        department: userDepartments.boAccountOpening.value,
    },
    secondaryPhone1: {
        label: 'Secondary Phone 1',
        path: 'secondaryPhones.secondaryPhone1',
        department: 'noDepartment',
    },
    secondaryPhone2: {
        label: 'Secondary Phone 2',
        path: 'secondaryPhones.secondaryPhone2',
        department: 'noDepartment',
    },
    secondaryPhone3: {
        label: 'Secondary Phone 3',
        path: 'secondaryPhones.secondaryPhone3',
        department: 'noDepartment',
    },
    secondaryEmail1: {
        label: 'Secondary Email 1',
        path: 'secondaryEmails.secondaryEmail1',
        department: 'noDepartment',
    },
    secondaryEmail2: {
        label: 'Secondary Email 2',
        path: 'secondaryEmails.secondaryEmail2',
        department: 'noDepartment',
    },
    secondaryEmail3: {
        label: 'Secondary Email 3',
        path: 'secondaryEmails.secondaryEmail3',
        department: 'noDepartment',
    },
    country: {
        label: 'Country',
        path: 'address.country',
        department: userDepartments.boAccountOpening.value,
    },
    line1: {
        label: 'Street',
        path: 'address.line1',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    houseNumber: {
        label: 'House Number',
        path: 'address.houseNumber',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    zip: {
        path: 'address.zip',
        label: 'Postal Code',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    city: {
        label: 'City',
        path: 'address.city',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    region: {
        label: 'Region',
        path: 'address.region',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    approxNetWorth: {
        label: 'Approx Net Worth',
        path: 'globalQuestionnaire.approxNetWorth',
        department: userDepartments.boFunding.value,
    },
    approxYearlyIncome: {
        label: 'Approx Yearly Income',
        department: userDepartments.boFunding.value,
        path: 'globalQuestionnaire.approxYearlyIncome',
    },
    sourceOfFunds: {
        label: 'Source Of Funds',
        path: 'globalQuestionnaire.sourceOfFunds',
        department: userDepartments.boFunding.value,
    },
    jobTitle: {
        label: 'Job Title - Industry',
        path: 'globalQuestionnaire.jobTitle',
        department: userDepartments.boFunding.value,
    },
    natureOfTransactions: {
        label: 'Nature Of Transaction',
        department: userDepartments.boFunding.value,
        path: 'globalQuestionnaire.natureOfTransactions',
    },
    originOfFunds: {
        label: 'Origin Of Funds',
        path: 'globalQuestionnaire.originOfFunds',
        department: userDepartments.boFunding.value,
    },
    approxExpectedDeposit: {
        label: 'Estimated Amount To Deposit',
        department: userDepartments.boFunding.value,
        path: 'globalQuestionnaire.approxExpectedDeposit',
    },
    transactionPurpose: {
        label: 'Transaction Purpose',
        department: userDepartments.boFunding.value,
        path: 'globalQuestionnaire.transactionPurpose',
    },
    politicallyExposed: {
        label: 'Politically Exposed',
        path: 'globalQuestionnaire.politicallyExposed',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    usCitizen: {
        label: 'US Citizen / Resident',
        path: 'globalQuestionnaire.usCitizen',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    tin: {
        label: 'TIN',
        path: 'globalQuestionnaire.tin',
        department: userDepartments.boAccountOpening.value,
    },
    tinReason: {
        label: 'TIN Reason',
        path: 'globalQuestionnaire.tinReason',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    taxJurisdictionCountry: {
        label: 'Tax Jurisdiction',
        path: 'globalQuestionnaire.taxJurisdictionCountry',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    mifirId: {
        path: 'mifirId',
        label: 'MiFIR Document ID',
        department: userDepartments.boAccountOpening.value,
    },
    mifirType: {
        path: 'mifirType',
        label: 'MiFIR Document Type',
        department: userDepartments.boAccountOpening.value,
    },
    expectedCountryOfOriginDestinationFunds: {
        path: 'globalQuestionnaire.expectedCountryOfOriginDestinationFunds',
        label: 'Expected Country Of Origin Destination Funds',
        department: userDepartments.boFunding.value,
    },
    placeOfBirth: {
        path: 'placeOfBirth',
        label: 'Place of Birth',
        department: userDepartments.boAccountOpening.value,
    },
    profession: {
        path: 'profession',
        label: 'Profession',
        department: userDepartments.boAccountOpening.value,
    },
    nationalIdNumber: {
        path: 'nationalIdNumber',
        label: 'National Id number',
        department: userDepartments.boAccountOpening.value,
        isStandaloneField: true,
    },
    localDepositorEmail: {
        path: 'localDepositorEmail',
        label: 'Local Depositor Email',
        department: userDepartments.boFunding.value,
    },
    localDepositorPhone: {
        path: 'localDepositorPhone',
        label: 'Local Depositor Phone',
        department: userDepartments.boFunding.value,
    },
});
export const bonusPercentages = generateKeys({
    30: {
        value: 30,
        label: '30%',
    },
    50: {
        value: 50,
        label: '50%',
    },
    100: {
        value: 100,
        label: '100%',
    },
});
export const bonusMaxPayouts = generateKeys({
    500: {
        value: 500,
        label: '500',
    },
    2500: {
        value: 2500,
        label: '2500',
    },
    5000: {
        value: 5000,
        label: '5000',
    },
    other: {
        value: 'other',
        label: 'other',
    },
});
export const educationalVideoLevels = generateLocalization('educationalVideoLevels', generateKeys({
    beginner: {
        label: 'Beginner',
        value: 'beginner',
        localization: { id: '', defaultMessage: '' },
    },
    intermediate: {
        label: 'Intermediate',
        value: 'intermediate',
        localization: { id: '', defaultMessage: '' },
    },
    advanced: {
        label: 'Advanced',
        value: 'advanced',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const tradingVideoTypes = generateKeys({
    cero: {
        value: 'cero',
    },
});
export const suportComplaintFormHelperTexts = generateLocalization('suportComplaintFormHelperTexts', generateKeys({
    personYouWereInContact: {
        value: 'personYouWereInContact',
        label: 'Person you were in contact with',
        localization: { id: '', defaultMessage: '' },
    },
    pleaseSpecifyCurrency: {
        value: 'pleaseSpecifyCurrency',
        label: 'Please specify the currency',
        localization: { id: '', defaultMessage: '' },
    },
    ifYes: {
        value: 'yes',
        label: 'If yes, please specify the below information: ',
        localization: { id: '', defaultMessage: '' },
    },
    ifNo: {
        value: 'no',
        label: 'If not, we encourage you to first contact our Customer Support department.',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const supportComplaintFormFields = generateLocalization('supportComplaintFormFields', generateKeys({
    fullNameAndSurname: {
        order: 1,
        required: true,
        type: 'textfield',
        label: 'Full Name and Surname',
        localization: { id: '', defaultMessage: '' },
    },
    registeredEmailAddress: {
        order: 2,
        required: true,
        type: 'textfield',
        validateEmail: true,
        label: 'Registered Email Address',
        localization: { id: '', defaultMessage: '' },
    },
    tradingAccountNumber: {
        order: 3,
        required: true,
        type: 'textfield',
        label: 'Trading Account Number',
        localization: { id: '', defaultMessage: '' },
    },
    hasCustomerSupportComplaint: {
        order: 4,
        required: true,
        type: 'radiogroup',
        helperText: [suportComplaintFormHelperTexts.ifYes, suportComplaintFormHelperTexts.ifNo],
        label: 'Did you communicate your complaint to our Customer Support Department?',
        localization: { id: '', defaultMessage: '' },
    },
    emailTicketNumber: {
        order: 5,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.yes.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Email ticket number (if any): ',
        localization: { id: '', defaultMessage: '' },
    },
    datesOfCommunication: {
        order: 6,
        required: false,
        type: 'textfield',
        prerequiredValue: yesNo.yes.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Date(s) of communication: ',
        localization: { id: '', defaultMessage: '' },
    },
    customerSupportRepresentative: {
        order: 7,
        required: false,
        type: 'textfield',
        prerequiredValue: yesNo.yes.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Name the Customer Support Representative',
        helperText: suportComplaintFormHelperTexts.personYouWereInContact,
        localization: { id: '', defaultMessage: '' },
    },
    outcome: {
        order: 8,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.yes.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Outcome: ',
        localization: { id: '', defaultMessage: '' },
    },
    dateTimeOfIssue: {
        order: 9,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.no.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Date & Time the issue arose',
        localization: { id: '', defaultMessage: '' },
    },
    positionsUnderDispute: {
        order: 10,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.no.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Position(s) number(s) under dispute',
        localization: { id: '', defaultMessage: '' },
    },
    disputeAmount: {
        order: 11,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.no.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Dispute amount',
        helperText: suportComplaintFormHelperTexts.pleaseSpecifyCurrency,
        localization: { id: '', defaultMessage: '' },
    },
    descriptionOfComplaint: {
        order: 12,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.no.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Brief Description of the Complaint',
        localization: { id: '', defaultMessage: '' },
    },
    descriptionOfComplaintResolution: {
        order: 13,
        required: true,
        type: 'textfield',
        prerequiredValue: yesNo.no.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Suggested way for the Complaint to be resolved',
        localization: { id: '', defaultMessage: '' },
    },
    attachSupportingEvidence: {
        order: 14,
        required: false,
        type: 'attachment',
        prerequiredValue: yesNo.no.value,
        prerequiredField: 'hasCustomerSupportComplaint',
        label: 'Please attach any supporting documentation/evidence such as screenshots, reports, error messages, and error codes (if any) that may help us in the investigation and resolution of the Complaint.',
        localization: { id: '', defaultMessage: '' },
    },
}));
